export const blockIconsHardwareSmartDisplayNew = (
	<span className='material-symbols-outlined'>smart_display</span>
);
